import React from "react";

import AboutUsSlice from "../../components/slices/aboutUs/AboutUsSlice";

const AboutUs = ({ slice }) => {
  return <AboutUsSlice slice={slice} />;
};

export default AboutUs;
